(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[88721,65250],{

/***/ 88721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HearingaidoffersWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/styles/variables/businessphonepricesVariables.module.scss
var businessphonepricesVariables_module = __webpack_require__(81331);
var businessphonepricesVariables_module_default = /*#__PURE__*/__webpack_require__.n(businessphonepricesVariables_module);
;// CONCATENATED MODULE: ./src/components/hearingaidoffers/logo/index.tsx


function HearingAidOffersLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "331",
        height: "36",
        viewBox: "0 0 331 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40.6775 28.4373H37.3359V3.9248H40.6775V14.2767H52.9711V3.9248H56.2818V28.4373H52.9711V17.4596H40.6775V28.4373Z",
                fill: "#32BCB0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M78.1525 19.213C78.1525 19.4371 78.1525 19.9856 78.0522 20.8431H63.9065C64.0814 22.3337 64.8296 23.6974 65.9923 24.645C67.155 25.5926 68.6407 26.0494 70.1343 25.9186C71.2494 25.908 72.3561 25.723 73.4141 25.3701C74.4568 25.0463 75.4415 24.5587 76.3312 23.9255L77.6895 26.3435C76.643 27.1183 75.478 27.7184 74.2399 28.1203C72.8986 28.5927 71.4867 28.8331 70.0648 28.831C68.5971 28.8666 67.1374 28.6038 65.7741 28.0585C64.6218 27.5994 63.6029 26.8583 62.8106 25.9032C62.0909 25.013 61.532 24.0038 61.1591 22.9212C60.78 21.823 60.5895 20.6685 60.5958 19.5066C60.5177 17.0531 61.4108 14.6681 63.0807 12.8705C63.9189 12.0033 64.9298 11.322 66.0479 10.8708C67.1659 10.4197 68.3662 10.2087 69.5709 10.2516C70.7106 10.21 71.8466 10.4031 72.9086 10.8191C73.9706 11.235 74.9359 11.8649 75.7447 12.6697C76.5651 13.5422 77.2011 14.5714 77.6148 15.6957C78.0286 16.82 78.2114 18.0163 78.1525 19.213V19.213ZM63.9065 18.0851H74.8727C74.866 17.4025 74.7224 16.7282 74.4502 16.1024C74.1779 15.4765 73.7828 14.9118 73.2882 14.4419C72.7935 13.972 72.2096 13.6064 71.571 13.367C70.9324 13.1276 70.2522 13.0192 69.5709 13.0482C68.2002 13.0284 66.8732 13.531 65.8589 14.4542C64.8165 15.4085 64.1282 16.6886 63.9065 18.0851V18.0851Z",
                fill: "#32BCB0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M95.9406 13.2487V10.6607H98.9889V28.429H95.9406V25.9105C95.2012 26.8588 94.2496 27.6198 93.1625 28.1324C92.0754 28.645 90.8832 28.8948 89.682 28.8616C88.4891 28.8918 87.3038 28.6646 86.2065 28.1954C85.1093 27.7261 84.1258 27.0259 83.323 26.1423C81.6344 24.3133 80.7286 21.8952 80.7994 19.4058C80.7553 18.1974 80.9562 16.9926 81.3899 15.864C81.8236 14.7354 82.4812 13.7065 83.323 12.8393C84.14 11.9806 85.1285 11.3036 86.2241 10.8524C87.3196 10.4012 88.4978 10.1859 89.682 10.2204C90.8886 10.2029 92.0827 10.4676 93.1692 10.9933C94.2557 11.519 95.2047 12.2913 95.9406 13.2487V13.2487ZM96.1413 19.5139C96.1877 17.8469 95.5812 16.2278 94.4512 15.0023C93.8954 14.3913 93.2133 13.9089 92.4523 13.5887C91.6912 13.2685 90.8696 13.1182 90.0447 13.1483C89.2241 13.1169 88.4067 13.2668 87.6504 13.5872C86.8942 13.9077 86.2177 14.3908 85.669 15.0023C84.6019 16.2765 84.0171 17.886 84.0171 19.5487C84.0171 21.2114 84.6019 22.8209 85.669 24.0951C86.2177 24.7066 86.8942 25.1897 87.6504 25.5102C88.4067 25.8306 89.2241 25.9805 90.0447 25.9491C90.8696 25.9792 91.6912 25.8289 92.4523 25.5087C93.2133 25.1885 93.8954 24.7061 94.4512 24.0951C95.5897 22.847 96.1961 21.2032 96.1413 19.5139Z",
                fill: "#32BCB0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M107.107 28.4367H103.928V10.6684H106.945V13.2873C107.387 12.3189 108.11 11.5062 109.02 10.955C109.93 10.4038 110.985 10.1397 112.047 10.1972C112.749 10.2035 113.448 10.2917 114.13 10.4598L113.829 13.55C113.229 13.3619 112.605 13.263 111.977 13.2564C111.316 13.2305 110.657 13.3507 110.048 13.6084C109.438 13.8661 108.893 14.255 108.45 14.7474C107.483 15.9553 107.004 17.4826 107.107 19.0272V28.4367Z",
                fill: "#32BCB0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M118.467 8.14248C118.163 8.15091 117.859 8.0978 117.576 7.98631C117.292 7.87481 117.033 7.70722 116.816 7.49355C116.598 7.28009 116.426 7.02366 116.312 6.74044C116.197 6.45722 116.143 6.15336 116.152 5.84806C116.145 5.55102 116.2 5.25581 116.315 4.98162C116.429 4.70744 116.6 4.46042 116.816 4.25664C117.262 3.83784 117.856 3.61287 118.467 3.63089C118.763 3.62651 119.056 3.68095 119.33 3.79102C119.604 3.90109 119.854 4.06462 120.065 4.27209C120.273 4.47151 120.439 4.71136 120.552 4.97701C120.664 5.24265 120.722 5.52852 120.721 5.81715C120.732 6.11938 120.682 6.4208 120.574 6.70312C120.466 6.98543 120.301 7.24276 120.09 7.45949C119.88 7.67622 119.627 7.84784 119.348 7.96392C119.069 8.07999 118.769 8.13811 118.467 8.13475V8.14248ZM120.011 10.6609V28.4292H116.831V10.6609H120.011Z",
                fill: "#32BCB0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M128.114 28.4368H124.934V10.6686H128.021V13.1871C129.148 11.2042 131.026 10.2102 133.655 10.2051C134.574 10.1783 135.489 10.3346 136.348 10.6648C137.206 10.995 137.991 11.4926 138.656 12.1287C140.009 13.4111 140.683 15.2574 140.677 17.6677V28.4446H137.529V18.5562C137.618 17.1197 137.176 15.7007 136.286 14.5699C135.879 14.1009 135.371 13.7297 134.8 13.4836C134.23 13.2376 133.612 13.123 132.991 13.1484C132.324 13.1354 131.663 13.2668 131.051 13.5334C130.44 13.8001 129.893 14.1958 129.449 14.6935C128.524 15.7837 128.039 17.1807 128.091 18.6102L128.114 28.4368Z",
                fill: "#32BCB0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M159.454 12.979V10.6614H162.602V26.6142C162.662 27.869 162.463 29.1227 162.018 30.2975C161.573 31.4723 160.892 32.543 160.017 33.4433C159.09 34.3141 157.997 34.9893 156.804 35.4286C155.611 35.8679 154.341 36.0624 153.071 36.0004C150.25 36.0234 147.496 35.1377 145.215 33.4742L146.705 30.9558C148.521 32.3485 150.745 33.1057 153.033 33.1111C153.886 33.1563 154.739 33.0299 155.542 32.7393C156.346 32.4487 157.082 31.9999 157.709 31.4193C158.283 30.8704 158.733 30.2054 159.03 29.4688C159.326 28.7322 159.463 27.9408 159.43 27.1472V25.6871C158.67 26.5915 157.714 27.3116 156.635 27.7933C155.557 28.275 154.383 28.5057 153.203 28.4682C152.018 28.5027 150.84 28.2874 149.745 27.8362C148.649 27.385 147.661 26.708 146.844 25.8493C146.004 24.9852 145.346 23.9619 144.907 22.8396C144.469 21.7173 144.259 20.5185 144.289 19.3137C144.27 18.1155 144.492 16.9257 144.942 15.815C145.391 14.7042 146.059 13.6952 146.906 12.8478C147.752 12.0005 148.76 11.332 149.87 10.882C150.979 10.4321 152.168 10.21 153.365 10.2287C154.521 10.2013 155.668 10.4341 156.722 10.9102C157.776 11.3862 158.709 12.0932 159.454 12.979V12.979ZM149.251 23.7944C150.407 24.9384 151.967 25.5801 153.592 25.5801C155.218 25.5801 156.777 24.9384 157.933 23.7944C158.503 23.2011 158.949 22.4999 159.245 21.7317C159.54 20.9636 159.679 20.1442 159.654 19.3214C159.684 18.5017 159.546 17.6845 159.251 16.9195C158.955 16.1545 158.507 15.4578 157.933 14.8717C157.371 14.2906 156.695 13.8321 155.947 13.5251C155.199 13.218 154.396 13.0689 153.588 13.0871C152.781 13.0638 151.978 13.2106 151.23 13.518C150.483 13.8254 149.809 14.2866 149.251 14.8717C148.676 15.4564 148.225 16.1527 147.928 16.9179C147.631 17.683 147.493 18.501 147.523 19.3214C147.491 20.1503 147.628 20.9769 147.925 21.7512C148.222 22.5254 148.673 23.2311 149.251 23.8253V23.7944Z",
                fill: "#32BCB0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M191.387 28.4373H186.225L184.403 23.1299H175.853L173.993 28.4373H168.861L178.206 3.9248H182.212L191.387 28.4373ZM183.007 18.7497L180.167 10.5686L177.249 18.7265L183.007 18.7497Z",
                fill: "#F6851F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M194.374 28.4373V3.9248H199.313V28.4373H194.374Z",
                fill: "#F6851F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214.122 28.4373H204.746V3.9248H214.315C218.004 3.9248 220.888 5.0321 222.966 7.24669C225.045 9.46128 226.094 12.4561 226.115 16.2312C226.115 20.0166 225.042 22.9832 222.897 25.154C220.752 27.3248 217.85 28.4373 214.122 28.4373ZM209.646 8.63725V23.7016H214.354C215.282 23.7481 216.208 23.5775 217.058 23.2034C217.909 22.8292 218.661 22.2619 219.254 21.5463C220.456 20.0064 221.077 18.0914 221.006 16.1385C221.073 14.2075 220.452 12.3156 219.254 10.8003C218.661 10.0847 217.909 9.51738 217.058 9.14325C216.208 8.76913 215.282 8.59853 214.354 8.64498L209.646 8.63725Z",
                fill: "#F6851F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M232.574 16.3316C232.539 14.6443 232.85 12.9678 233.487 11.4054C234.124 9.8429 235.074 8.42757 236.279 7.24661C237.453 6.07029 238.848 5.13709 240.383 4.50027C241.917 3.86346 243.562 3.53552 245.224 3.53516C246.885 3.5348 248.531 3.86204 250.066 4.49819C251.601 5.13434 252.996 6.06694 254.171 7.24275C255.346 8.41856 256.278 9.81455 256.914 11.351C257.551 12.8875 257.878 14.5343 257.879 16.1975C257.879 17.8607 257.552 19.5077 256.917 21.0445C256.281 22.5812 255.349 23.9776 254.175 25.1539C252.993 26.346 251.583 27.2864 250.028 27.9184C248.474 28.5503 246.808 28.8608 245.13 28.8312C243.48 28.8592 241.84 28.5555 240.309 27.9381C238.777 27.3207 237.385 26.4022 236.214 25.2368C235.044 24.0715 234.118 22.6829 233.493 21.1533C232.868 19.6237 232.555 17.9842 232.574 16.3316ZM254.468 16.2312C254.501 14.9806 254.281 13.7364 253.82 12.5734C253.36 11.4103 252.67 10.3526 251.79 9.46378C250.942 8.58407 249.922 7.88865 248.793 7.42081C247.665 6.95297 246.452 6.72275 245.231 6.74447C244.011 6.7245 242.8 6.95945 241.676 7.43432C240.552 7.9092 239.539 8.61356 238.702 9.50241C236.987 11.3159 236.031 13.7184 236.031 16.2157C236.031 18.713 236.987 21.1155 238.702 22.929C240.451 24.652 242.807 25.6177 245.261 25.6177C247.716 25.6177 250.072 24.652 251.821 22.929C252.694 22.0511 253.378 21.0045 253.833 19.8529C254.289 18.7013 254.504 17.469 254.468 16.2312V16.2312Z",
                fill: "#32BCB0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M282.667 5.84761C282.163 5.81242 281.657 5.87834 281.178 6.04151C280.7 6.20468 280.259 6.46181 279.881 6.79783C279.546 7.17134 279.291 7.60913 279.13 8.08458C278.97 8.56003 278.907 9.06321 278.947 9.56349V10.6605H284.573V13.3798H278.947V28.4365H275.768V13.3798H266.53V28.4365H263.351V13.3798H260.264V10.6605H263.351V9.50169C263.297 8.6004 263.441 7.69826 263.773 6.85875C264.105 6.01923 264.617 5.26274 265.272 4.64247C266.73 3.41439 268.602 2.7899 270.505 2.89654C272.261 2.90746 273.989 3.33925 275.544 4.15577L274.417 6.74375C273.278 6.22808 272.054 5.92442 270.806 5.84761C269.674 5.77884 268.556 6.12179 267.657 6.81328C267.275 7.15774 266.976 7.58379 266.78 8.05986C266.585 8.53594 266.5 9.04983 266.53 9.56349V10.6605H275.745V9.50169C275.665 8.61763 275.779 7.7268 276.08 6.8918C276.381 6.0568 276.861 5.29788 277.486 4.66836C278.111 4.03885 278.867 3.55401 279.699 3.24792C280.531 2.94182 281.421 2.82189 282.304 2.89654C283.708 2.88586 285.093 3.21728 286.34 3.86221L285.353 6.48109C284.507 6.09578 283.595 5.88054 282.667 5.84761V5.84761Z",
                fill: "#32BCB0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M303.272 19.2126C303.272 19.4366 303.272 19.9851 303.172 20.8426H289.026C289.205 22.3316 289.954 23.693 291.116 24.6398C292.277 25.5867 293.761 26.045 295.254 25.9181C296.369 25.9081 297.476 25.723 298.534 25.3697C299.576 25.0459 300.561 24.5582 301.451 23.925L302.809 26.343C301.764 27.1163 300.602 27.7163 299.367 28.1199C298.025 28.591 296.614 28.8313 295.192 28.8306C293.724 28.8676 292.264 28.6048 290.901 28.0581C289.746 27.601 288.724 26.8597 287.93 25.9027C287.211 25.0149 286.652 24.0084 286.279 22.9284C285.899 21.8303 285.709 20.6757 285.715 19.5139C285.641 17.0619 286.537 14.6799 288.208 12.8855C289.046 12.0183 290.057 11.337 291.175 10.8858C292.293 10.4347 293.493 10.2237 294.698 10.2666C295.838 10.2236 296.974 10.4161 298.036 10.8321C299.099 11.2482 300.064 11.8788 300.872 12.6847C301.69 13.5549 302.325 14.5817 302.737 15.7035C303.15 16.8252 303.332 18.0188 303.272 19.2126V19.2126ZM289.026 18.0847H299.992C299.985 17.4021 299.842 16.7278 299.57 16.1019C299.297 15.476 298.902 14.9113 298.408 14.4414C297.913 13.9715 297.329 13.606 296.69 13.3666C296.052 13.1271 295.372 13.0187 294.69 13.0478C293.32 13.028 291.993 13.5306 290.978 14.4538C289.936 15.4081 289.248 16.6881 289.026 18.0847V18.0847Z",
                fill: "#32BCB0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M310.194 28.4374H307.015V10.6691H310.032V13.288C310.475 12.3203 311.198 11.5082 312.108 10.9571C313.017 10.406 314.072 10.1415 315.133 10.1979C315.836 10.2042 316.535 10.2924 317.217 10.4605L316.924 13.5507C316.321 13.3621 315.695 13.2632 315.064 13.2571C314.403 13.2312 313.744 13.3514 313.134 13.6091C312.525 13.8668 311.98 14.2557 311.537 14.7481C310.57 15.956 310.091 17.4833 310.194 19.0279V28.4374Z",
                fill: "#32BCB0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M324.61 28.831C323.259 28.8473 321.928 28.5062 320.751 27.8422C319.569 27.1802 318.606 26.1867 317.981 24.9838L320.296 23.2302C320.739 24.0901 321.409 24.8116 322.233 25.316C322.972 25.785 323.827 26.0391 324.703 26.0499C325.519 26.0843 326.321 25.833 326.972 25.3392C327.243 25.1365 327.463 24.8731 327.615 24.5699C327.766 24.2667 327.844 23.9322 327.844 23.5933C327.824 23.0996 327.66 22.6225 327.372 22.2214C327.084 21.8203 326.684 21.5129 326.223 21.3375C325.935 21.183 325.194 20.8508 324 20.3409C322.897 19.8774 322.171 19.5684 321.816 19.3521C320.997 18.9723 320.304 18.3632 319.822 17.5984C319.34 16.8336 319.089 15.9456 319.1 15.0413C319.084 14.3679 319.219 13.6995 319.494 13.0847C319.769 12.4699 320.177 11.9243 320.69 11.4877C321.858 10.4927 323.364 9.98399 324.896 10.0662C326.019 10.0595 327.13 10.3078 328.145 10.7924C329.123 11.2441 329.951 11.9682 330.529 12.8783L328.507 14.8019C328.098 14.1656 327.535 13.6434 326.869 13.2841C326.204 12.9248 325.459 12.74 324.703 12.7469C324.027 12.7126 323.364 12.9331 322.843 13.365C322.619 13.5542 322.441 13.7912 322.32 14.0586C322.2 14.326 322.141 14.6169 322.148 14.91C322.15 15.3703 322.294 15.8189 322.56 16.1939C322.827 16.5688 323.204 16.8517 323.638 17.0036L325.598 17.8611C326.416 18.1733 327.213 18.5398 327.983 18.9581C329.989 19.9881 330.992 21.4817 330.992 23.4388C331.003 24.1759 330.848 24.906 330.538 25.5747C330.228 26.2434 329.771 26.8336 329.202 27.3014C327.909 28.3546 326.276 28.8986 324.61 28.831Z",
                fill: "#32BCB0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.7349 9.91947C22.7349 9.91947 22.7349 9.85767 22.7349 9.72634C22.7318 9.69293 22.7318 9.65931 22.7349 9.6259C22.7349 9.6259 22.7349 9.54093 22.7349 9.49457C22.7349 9.44822 22.7349 9.28599 22.7349 9.16239C22.7349 9.03878 22.7349 8.892 22.7349 8.73749V8.35895V8.21989V8.08084C22.7387 8.03199 22.7387 7.98291 22.7349 7.93406V7.62505C22.7349 7.51689 22.6886 7.40873 22.6732 7.30058V7.21561V7.13063L22.6269 6.95294C22.4902 6.4217 22.3042 5.90442 22.0712 5.40788C22.0712 5.40788 22.0712 5.34608 22.0172 5.30745L21.9709 5.20702L21.8629 5.00616L21.7471 4.79758L21.6236 4.59672C21.4509 4.30936 21.2602 4.03327 21.0526 3.77011L20.8905 3.56153L20.713 3.36067C20.658 3.29017 20.5987 3.22309 20.5355 3.15981L20.3426 2.95123C20.2191 2.8199 20.0802 2.68856 19.9413 2.55723L19.7252 2.3641L19.5014 2.17869C18.8551 1.64679 18.1416 1.20262 17.3792 0.857664H17.302H17.2248L17.0705 0.79586L16.9161 0.726335L16.7618 0.664531L16.5997 0.610454H16.5226H16.4377L16.1058 0.5023L15.774 0.409594H15.6582H15.5888H15.4344H15.365H15.2801H15.0949C14.9751 0.384581 14.854 0.366525 14.7322 0.355517C14.6164 0.355517 14.5006 0.355519 14.3772 0.309167L14.0222 0.270538H13.6595H13.289C12.7935 0.263383 12.2981 0.294378 11.8073 0.363244C10.7938 0.496422 9.80084 0.755946 8.85162 1.13578C7.86362 1.52317 6.9236 2.02348 6.05026 2.62676C5.6051 2.93992 5.17984 3.28049 4.77692 3.64651L4.47595 3.92462L4.18269 4.21818C4.08237 4.31861 3.98976 4.41131 3.89715 4.51947L3.75825 4.67398L3.68879 4.75123V4.78985L3.56532 4.93663L3.44184 5.09114L3.30293 5.2611L3.17174 5.43105L2.92479 5.76324C2.84761 5.87912 2.76272 5.99501 2.69327 6.11089C2.38093 6.57185 2.09743 7.05173 1.84437 7.54779C1.33758 8.53258 0.93661 9.56842 0.648197 10.6379C0.359081 11.7165 0.180665 12.8218 0.115712 13.9366C0.0848019 14.4899 0.0848019 15.0444 0.115712 15.5976V16.0147V16.4319V16.6405V16.7409V16.8645L0.169732 17.2508V17.4439V17.5366C0.173343 17.5519 0.173343 17.5677 0.169732 17.583V17.6371L0.246903 18.0542V18.2628V18.371V18.4714L0.331793 18.8731L0.378095 19.074V19.1667V19.2671C0.378095 19.3984 0.447554 19.5298 0.478423 19.6611C0.540161 19.9238 0.625045 20.1864 0.702217 20.4336C1.32453 22.4302 2.22056 24.3308 3.36467 26.0808C3.90226 26.9077 4.48449 27.7046 5.10876 28.468L5.348 28.7461C5.42517 28.8388 5.50234 28.9315 5.58723 29.0165C5.67212 29.1014 5.90364 29.3796 6.0657 29.5495C6.39754 29.8972 6.72938 30.2216 7.07666 30.5384C7.42393 30.8551 7.77121 31.1487 8.13392 31.419C8.49663 31.6894 8.90564 31.9444 9.2452 32.1916C9.97384 32.6361 10.7505 32.9963 11.5604 33.2654L11.8536 33.3504L12.1469 33.4276L12.4401 33.4971L12.7411 33.5589L13.0189 33.5976H13.3199H13.6054H13.891C14.257 33.6032 14.6231 33.5852 14.9868 33.5435C15.3244 33.4969 15.6593 33.4325 15.9901 33.3504C16.5874 33.1966 17.163 32.9682 17.7033 32.6705L17.7959 32.6242L17.8885 32.5701L18.066 32.462L18.3978 32.2379L18.5522 32.1298L18.6988 32.0139L18.7683 31.9521L18.8377 31.8903L18.9689 31.7744C19.2784 31.4972 19.5531 31.1833 19.7869 30.8396C19.8377 30.7705 19.8841 30.6983 19.9259 30.6233L20.0493 30.4225L20.1497 30.2293L20.196 30.1366V30.0517L20.2654 29.8894L20.3194 29.7504L20.358 29.6268C20.3614 29.5934 20.3614 29.5597 20.358 29.5263L20.412 29.3487L20.3349 29.5186L20.2886 29.6113L20.2268 29.7272C20.2079 29.7731 20.1847 29.8171 20.1574 29.8585L20.0725 30.0053C20.0107 30.1057 19.9259 30.2139 19.8487 30.3375L19.7021 30.5152C19.6558 30.577 19.594 30.6388 19.54 30.7006C19.2771 30.988 18.9849 31.2469 18.6679 31.4731L18.529 31.5658L18.4596 31.6122L18.3824 31.6585L18.2358 31.7512L18.0814 31.8362L17.7496 32.0062L17.5798 32.0911H17.4872H17.4023C17.1516 32.1968 16.8937 32.2846 16.6306 32.3538C16.3516 32.4327 16.0681 32.4946 15.7817 32.5392L15.3264 32.5933H15.0949H14.8633C14.5385 32.6008 14.2136 32.5853 13.891 32.5469H13.644H13.3971L13.1578 32.4929L12.8877 32.4233H12.8414H12.7797H12.6562L12.4016 32.3383L12.1469 32.2456L11.8999 32.1452C11.2001 31.85 10.5371 31.474 9.92432 31.025C9.60791 30.7933 9.2915 30.5383 8.98281 30.2525C8.67413 29.9667 8.38087 29.6886 8.08761 29.3873C7.79436 29.086 7.50883 28.7538 7.231 28.4139L6.82199 27.8963L6.62134 27.6336L6.42841 27.3632L6.37439 27.2937L6.32808 27.2242L6.22776 27.0851L6.03483 26.807C5.97309 26.7066 5.91135 26.6139 5.8419 26.5212L5.65669 26.2276C5.53321 26.0345 5.40974 25.8414 5.29398 25.6405C5.17822 25.4396 5.04703 25.2465 4.93898 25.0457C3.99164 23.3943 3.26514 21.6255 2.77816 19.7847C2.72414 19.5529 2.65468 19.3212 2.61609 19.0817C2.61609 18.9658 2.56208 18.8499 2.53892 18.7341V18.6414C2.53592 18.6131 2.53592 18.5846 2.53892 18.5564V18.3787C2.53892 18.2551 2.49262 18.1392 2.47718 18.0233C2.47347 17.9925 2.47347 17.9614 2.47718 17.9306V17.8456V17.6757L2.43088 17.3281V17.2817C2.434 17.2664 2.434 17.2506 2.43088 17.2353V17.1426V16.9495V16.5632V16.2311V15.5126C2.43088 15.0336 2.45403 14.5547 2.50033 14.0757C2.67119 12.1853 3.21411 10.3474 4.0978 8.66797C4.3216 8.26625 4.56084 7.89543 4.81551 7.50144C4.87724 7.40874 4.9467 7.32376 5.01616 7.23105C5.08561 7.13835 5.14735 7.05337 5.21681 6.96067L5.31713 6.83706L5.41745 6.71346L5.53321 6.5744L5.65669 6.43535L5.71071 6.38127L5.82646 6.25766C5.89592 6.17268 5.98081 6.10316 6.05798 6.01818C6.13515 5.9332 6.21233 5.8714 6.2895 5.79414L6.53645 5.57011C6.86379 5.29347 7.20646 5.03555 7.56284 4.79758C8.25797 4.32041 9.00649 3.92632 9.79313 3.62333C11.2432 3.05856 12.8052 2.84161 14.354 2.98985H14.6087H14.7322H14.8016H14.8788H15.0331H15.1026H15.1566L15.4036 3.0362L15.6582 3.09801H15.72H15.7817H15.9052H16.0286L16.1444 3.13663H16.2679H16.3296H16.3836C16.9993 3.33489 17.5939 3.59366 18.1586 3.90916C18.4287 4.0714 18.6834 4.24136 18.9303 4.41904L19.1078 4.55037L19.2853 4.68942L19.4551 4.82075L19.6172 4.95981C19.841 5.14522 20.0339 5.33835 20.2345 5.53149L20.5046 5.81732L20.6358 5.9641L20.6976 6.03363L20.7593 6.11089C21.0612 6.4684 21.3396 6.84516 21.5928 7.23878C21.7085 7.42419 21.8089 7.60187 21.9015 7.77182L22.0327 8.01903L22.1484 8.25852C22.2256 8.41303 22.2796 8.55981 22.3413 8.69887L22.4185 8.892L22.488 9.07741C22.488 9.18556 22.5574 9.28599 22.596 9.37869C22.6346 9.4714 22.6423 9.54093 22.6655 9.60273C22.6886 9.66453 22.7195 9.78813 22.7195 9.78813L22.7349 9.91947Z",
                fill: "#00BAC2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.47355 7.16944L8.62018 7.08446L9.03691 6.86042C9.22213 6.75999 9.46136 6.65184 9.73918 6.53596C10.0595 6.40936 10.3867 6.30103 10.7193 6.2115C11.6149 5.96124 12.5468 5.86716 13.4743 5.93338C13.7333 5.95607 13.9908 5.99217 14.246 6.04154C14.5248 6.09649 14.8004 6.16612 15.0718 6.25013C15.6572 6.44388 16.219 6.70302 16.7464 7.02266L16.9471 7.15399L17.0551 7.21579H17.1014C17.2351 7.30683 17.3639 7.40482 17.4873 7.50935C17.7494 7.71607 17.9922 7.9462 18.2127 8.1969C18.6835 8.71148 19.0644 9.3017 19.3394 9.94283C19.635 10.6011 19.7875 11.3147 19.787 12.0364C19.7881 12.7616 19.5819 13.4719 19.1928 14.0836C19.0909 14.2393 18.9801 14.3889 18.861 14.5317C18.7375 14.6707 18.6063 14.8098 18.4674 14.9488C18.176 15.2264 17.8666 15.4845 17.5413 15.7214C17.2017 15.9609 16.8468 16.1926 16.4763 16.4321L16.1985 16.6175L16.0596 16.7102L15.9824 16.7643L15.913 16.8106L15.8358 16.8724L15.7586 16.9265L15.612 17.0501C15.5114 17.1288 15.416 17.214 15.3265 17.3051C14.9544 17.6636 14.6441 18.0812 14.4081 18.5411C14.1593 19.0235 13.9998 19.5469 13.9374 20.0862C13.8784 20.602 13.9045 21.1239 14.0145 21.6312C14.1271 22.1413 14.3171 22.6311 14.5779 23.0836C14.7076 23.3074 14.8493 23.524 15.0023 23.7325L15.1181 23.8793L15.1721 23.9488H15.2107L15.2802 24.0261L15.4036 24.1574C15.7073 24.4515 15.9958 24.7609 16.268 25.0845C16.3219 25.1502 16.371 25.22 16.4146 25.293V25.3394V25.3935V25.4321V25.5093V25.5634L16.4609 25.6793C16.4861 25.7494 16.5042 25.8219 16.5149 25.8956C16.5416 26.023 16.5416 26.1545 16.5149 26.2819C16.5001 26.3947 16.4606 26.5029 16.3992 26.5986C16.238 26.8306 16.0127 27.0105 15.7509 27.1162C15.438 27.2527 15.1037 27.3337 14.7631 27.3557C14.4073 27.388 14.0488 27.3698 13.6981 27.3016L13.4435 27.2398H13.3663H13.2505C13.0865 27.1842 12.9266 27.1171 12.7721 27.039C12.1413 26.7098 11.5886 26.2488 11.1514 25.687C11.0434 25.548 10.9354 25.4089 10.8427 25.2621V25.2003V25.154L10.7656 25.0227L10.6498 24.8141C10.4898 24.5101 10.3581 24.192 10.2562 23.8639C10.1551 23.5435 10.0803 23.2153 10.0324 22.8827C9.98524 22.5605 9.96459 22.235 9.9707 21.9094C9.98354 21.2872 10.0875 20.6703 10.2794 20.0784C10.458 19.5277 10.7181 19.0068 11.0511 18.5334C11.3462 18.1009 11.6936 17.7065 12.0852 17.3591C12.436 17.0421 12.8188 16.7625 13.2274 16.5248L13.5129 16.3703L13.6518 16.293L13.7907 16.2312C13.9759 16.1385 14.1612 16.069 14.3387 15.9995C14.8904 15.7903 15.4658 15.6502 16.0519 15.5823H16.322H16.5303H16.6924V15.536L16.5303 15.4896L16.3297 15.4355L16.0519 15.3815C15.4234 15.2769 14.7819 15.2769 14.1534 15.3815C13.9451 15.3815 13.7367 15.4587 13.5129 15.5128C13.2769 15.5694 13.0448 15.6416 12.8184 15.7291C12.2971 15.9195 11.8039 16.1793 11.3521 16.5016C10.8199 16.859 10.3439 17.2938 9.93983 17.7918C9.48504 18.3496 9.12523 18.9786 8.87485 19.6536C8.60158 20.3968 8.45042 21.1795 8.42725 21.9712C8.4146 22.3814 8.43266 22.792 8.48127 23.1995C8.53534 23.623 8.62309 24.0415 8.74366 24.451C8.8735 24.8711 9.03873 25.2794 9.23756 25.6716L9.40734 25.9729L9.48451 26.1042L9.53082 26.1815L9.57712 26.251C9.70059 26.4467 9.83179 26.6321 9.9707 26.8072C10.2574 27.169 10.5778 27.5027 10.9276 27.8038C11.2931 28.1096 11.6948 28.369 12.1238 28.5763C12.3457 28.6899 12.5752 28.788 12.8106 28.8699L13.0036 28.9317H13.0807H13.1348L13.4975 29.0167C14.0058 29.1149 14.5254 29.1409 15.0409 29.0939C15.5743 29.0528 16.0965 28.9195 16.5844 28.6999C16.8607 28.5829 17.1202 28.4297 17.3561 28.2441C17.5963 28.0447 17.8023 27.8072 17.9658 27.5411C18.1372 27.2602 18.25 26.9475 18.2976 26.6218C18.3409 26.3075 18.3252 25.9878 18.2513 25.6793C18.2209 25.5356 18.1823 25.3937 18.1355 25.2544C18.1355 25.1849 18.0815 25.1231 18.0506 25.0613C18.0527 25.0253 18.0527 24.9891 18.0506 24.9531V24.9068V24.8604V24.7909V24.7523V24.7059L17.9966 24.6132L17.9426 24.5205C17.8665 24.4028 17.7841 24.2893 17.6957 24.1806C17.533 23.9863 17.3605 23.8007 17.1786 23.6244L16.7078 23.1609L16.5998 23.0527L16.5072 22.96L16.4532 22.8905L16.3606 22.7746C16.2438 22.6237 16.1356 22.4664 16.0364 22.3033C15.8403 21.9824 15.6946 21.6333 15.6043 21.2681C15.5148 20.9151 15.4861 20.5493 15.5194 20.1866C15.5977 19.4504 15.9212 18.762 16.4377 18.2321L16.6461 18.039L16.7464 17.9463L16.8005 17.8999H16.8545L16.9162 17.8536L16.9779 17.8072L17.1091 17.7145L17.3715 17.5291C17.7265 17.2742 18.0892 17.0192 18.4519 16.7566C18.8182 16.4782 19.1639 16.1735 19.4861 15.845C19.6506 15.6792 19.8052 15.5037 19.9491 15.3197C20.095 15.1326 20.2291 14.9365 20.3504 14.7325C20.5924 14.3229 20.7743 13.8806 20.8906 13.4192C20.9965 12.9714 21.0458 12.512 21.0372 12.0518C21.0046 11.1856 20.7917 10.3357 20.4121 9.55656C20.0648 8.8311 19.6037 8.16602 19.0462 7.5866C18.7821 7.30622 18.4956 7.04786 18.1896 6.81407C18.0442 6.69722 17.8921 6.58889 17.7342 6.48961H17.6725L17.5567 6.42008L17.3252 6.28875C16.7318 5.9545 16.0993 5.69502 15.4422 5.51622C15.1369 5.44229 14.8278 5.38554 14.5161 5.34626L14.0685 5.30764H13.4743C13.1984 5.30701 12.9227 5.32249 12.6486 5.35399C12.3893 5.38149 12.1317 5.42276 11.8769 5.47759C11.441 5.56858 11.0146 5.70049 10.6035 5.87158C10.2732 6.00139 9.95326 6.15635 9.64658 6.3351C9.41789 6.46469 9.19634 6.60653 8.98289 6.75999L8.59703 7.05355L8.47355 7.16171V7.16944Z",
                fill: "#00BAC2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3947 20.7652C17.3947 21.303 17.554 21.8288 17.8525 22.276C18.1509 22.7232 18.5752 23.0717 19.0716 23.2775C19.5679 23.4833 20.1141 23.5372 20.6411 23.4323C21.168 23.3273 21.652 23.0684 22.0319 22.6881C22.4119 22.3077 22.6706 21.8232 22.7754 21.2957C22.8802 20.7682 22.8264 20.2215 22.6208 19.7246C22.4152 19.2277 22.067 18.803 21.6203 18.5042C21.1736 18.2054 20.6484 18.0459 20.1111 18.0459C19.3907 18.0459 18.6997 18.3324 18.1903 18.8424C17.6809 19.3523 17.3947 20.044 17.3947 20.7652Z",
                fill: "#F09027"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.8186 20.7658C24.8192 19.8738 24.4833 19.0144 23.878 18.3598C23.2727 17.7051 22.4427 17.3035 21.5542 17.2354H21.832C22.7715 17.2354 23.6724 17.6089 24.3367 18.2739C25.001 18.9389 25.3742 19.8408 25.3742 20.7813C25.3742 21.7217 25.001 22.6236 24.3367 23.2886C23.6724 23.9536 22.7715 24.3272 21.832 24.3272H21.5542C22.4427 24.259 23.2727 23.8574 23.878 23.2028C24.4833 22.5481 24.8192 21.6888 24.8186 20.7967V20.7658Z",
                fill: "#F09027"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.5428 20.7661C27.5476 19.4075 27.0414 18.0968 26.1248 17.0948C25.2082 16.0928 23.9485 15.4729 22.5961 15.3584H23.0823C24.5221 15.3584 25.903 15.931 26.9212 16.9502C27.9393 17.9694 28.5113 19.3518 28.5113 20.7932C28.5113 22.2346 27.9393 23.6169 26.9212 24.6361C25.903 25.6553 24.5221 26.2279 23.0823 26.2279H22.5961C23.9485 26.1134 25.2082 25.4935 26.1248 24.4915C27.0414 23.4895 27.5476 22.1788 27.5428 20.8202V20.7661Z",
                fill: "#F09027"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.7532 20.766C30.7534 19.5343 30.4342 18.3237 29.8268 17.2526C29.2195 16.1814 28.3447 15.2865 27.2882 14.6553C28.5435 15.1091 29.6286 15.9393 30.3955 17.0328C31.1624 18.1263 31.5739 19.4299 31.5739 20.766C31.5739 22.1021 31.1624 23.4057 30.3955 24.4992C29.6286 25.5927 28.5435 26.4229 27.2882 26.8767C28.3447 26.2455 29.2195 25.3506 29.8268 24.2794C30.4342 23.2083 30.7534 21.9977 30.7532 20.766V20.766Z",
                fill: "#F09027"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/hearingAidOffersWrapper.tsx









const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function HearingaidoffersWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Hearing Aid Offers",
                    domain: "HearingAidOffers.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Hearing Aid Offers",
                    domain: "HearingAidOffers.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        textColor: (businessphonepricesVariables_module_default()).goGoGreen,
                        slogan: "TOP HEARING AIDS SPECIALIST",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HearingAidOffersLogo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        textColor: "#52c9d1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 81331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"goGoGreen":"#008a7b","green":"#5bc1a4","bankVault":"#747474","autumnGlory":"#3ea636","offerBorderColor":"#e4e7eb"};

/***/ })

}]);